<div class="dialogue-content">
    <div class="mat-dialogue-header"></div>
    <mat-dialog-content>
        <div class="text-center">
            <form novalidate>
                <img src="../../../assets/images/manufacture.svg" class="mb-4 m-auto d-table" />

                <h5 class="text-primary">{{ action }} {{ type }}</h5>
                <p>
                    Are you sure you want to {{ action | lowercase }} this {{ type | lowercase }}?
                </p>

                <div class="mt-3 manufacture-date-wrap">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Manufacture Date</mat-label>
                        <input matInput [matDatepicker]="manufacturePicker" [(ngModel)]="manufactureDate"
                            name="manufactureDate" placeholder="Select date" [max]="maxDate" readonly required />
                        <mat-datepicker-toggle matIconSuffix [for]="manufacturePicker"></mat-datepicker-toggle>
                        <mat-datepicker #manufacturePicker></mat-datepicker>
                        <mat-hint>Choose when these NFC URLs were manufactured</mat-hint>
                    </mat-form-field>
                </div>

                <div class="d-flex align-items-center mt-4 flex-wrap justify-content-center gap-3">
                    <button matButton="filled" type="button" class="dialog-btn-secondary" mat-dialog-close
                        (click)="close()">No, Keep it!</button>
                    <button mat-flat-button type="button" class="dialog-btn-primary" (click)="confirmManufacture()"
                        [disabled]="!manufactureDate">
                        Yes, {{ action }}!
                    </button>
                </div>
            </form>
        </div>
    </mat-dialog-content>
</div>
